// 抽奖点击
import store from '@/store'

function addUrlToken(url, token) {
  // 检查URL中是否存在#
  const hashIndex = url.indexOf('#');
  if (hashIndex !== -1) {
    // 如果存在#，则在其之前插入urlToken参数
    // 检查URL中是否已有查询参数
    const hasQueryParams = url.indexOf('?') !== -1;
    // 根据是否已有查询参数决定是添加&还是?
    const separator = hasQueryParams ? '&' : '?';
    // 构建新的URL
    const newUrl = url.substring(0, hashIndex) + separator + 'urlToken=' + token + url.substring(hashIndex);
    return newUrl;
  } else {
    // 如果不存在#，则直接在URL末尾添加参数
    const hasQueryParams = url.indexOf('?') !== -1;
    const separator = hasQueryParams ? '&' : '?';
    return url + separator + 'urlToken=' + token;
  }
}

export const useCommonLotteryEffect = (resInfo) => {
  // 抽奖点击
  const handleLotteryClick = () => {

    console.log('resInfo.lotteryUrl', resInfo)

    if (resInfo.lotteryUrl.indexOf('lottery.cq.qiludev.com') !== -1) {
      resInfo.lotteryUrl = resInfo.lotteryUrl.replace('https', 'http')
    }

    // 判断一下url是否是抽奖
    if (resInfo.lotteryUrl.indexOf('app-hd.litenews.cn') !== -1
        || resInfo.lotteryUrl.indexOf('lottery.cq.qiludev.com') !== -1) {
      const token = store.getters?.getToken

      window.location.href = addUrlToken(resInfo.lotteryUrl, token)

      return
    }

    if (resInfo.lotteryUrl) {
      window.location.href = resInfo.lotteryUrl
    }
  }

  return {
    handleLotteryClick,
  }
}
